import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, mainColor, secondaryColor, iconColor) => ({
  icon: {
    p: "5px",
    height: {
      xs: "13px",
    },
    width: { xs: "13px" },
    borderRadius: "58px",
    bgcolor: theme.palette.white.secondary,
    color: iconColor,
    ml: { xs: "5px" },
  },
  button: {
    borderRadius: "100px",
    color: theme.palette.white.secondary,
    background: `linear-gradient(103deg, ${mainColor}, ${secondaryColor})`,
    fontSize: {
      xs: "16px",
      lg: "17px",
      xl: "18px",
    },
    lineHeight: {
      xs: "28.8px",
      lg: "31px",
      xl: "32.4px",
    },
    height: {
      xs: "52px",
      md: "56px",
      lg: "60px",
      xl: "64px",
    },
    width: {
      xs: "197px",
      md: "220px",
      lg: "240px",
      xl: "254px",
    },
    textTransform: "none",
    "&:hover": {
      color: theme.palette.white.secondary,
      background: `linear-gradient(103deg, ${mainColor}, ${secondaryColor})`,
    },
    letterSpacing: { xs: "0.28px", md: "0.36px" },
  },
});

const WantToStartButton = ({
  mb,
  mt,
  mainColor,
  secondaryColor,
  iconColor,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme, mainColor, secondaryColor, iconColor);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { title } = useTranslation(pathname, "WantToStartButton");

  const handleRedirect = () => {
    navigate("/aplica");
    window.scrollTo(0, 0);
  };

  return (
    <Button
      endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
      variant="contained"
      sx={{ ...classes.button, mb, mt }}
      onClick={handleRedirect}
    >
      {title}
    </Button>
  );
};

export default WantToStartButton;
